import { render, staticRenderFns } from "./SummarySection.vue?vue&type=template&id=528b400f"
import script from "./SummarySection.vue?vue&type=script&lang=js"
export * from "./SummarySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports